/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export type Direction =
  'inbound' | 
  'outbound'


export function DirectionFromJSON(json: any): Direction {
    return DirectionFromJSONTyped(json, false);
}

export function DirectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Direction {
    return json as Direction;
}

export function DirectionToJSON(value?: Direction | null): any {
    return value as any;
}

